/* eslint-disable react/no-multi-comp, max-lines, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toRoman } from 'helpers'
import { floats } from 'react-wot-bootstrap/lib/helpers/format_number'

import {
    BATTLE_TYPES,
    BONUS_TYPES,
    BUILDING_TYPES,
    RESERVE_TYPES,
    UNIT_TYPES,
    USER_ROLES as ROLES,
} from 'constants'

export const BONUS_TYPE_MESSAGES = {
    [BONUS_TYPES.EXTRA_CREW_XP]: (
        <FormattedMessage
            id='bonus_type.extra_crew_xp'
            defaultMessage='к опыту экипажа'
        />
    ),
    [BONUS_TYPES.EXTRA_BATTLE_XP]: (
        <FormattedMessage
            id='bonus_type.extra_battle_xp'
            defaultMessage='к боевому опыту'
        />
    ),
    [BONUS_TYPES.EXTRA_INDUSTRIAL_RESOURCE]: (
        <FormattedMessage
            id='bonus_type.extra_industrial_resource'
            defaultMessage='к промресурсу'
        />
    ),
    [BONUS_TYPES.EXTRA_CREDITS]: (
        <FormattedMessage
            id='bonus_type.extra_credits'
            defaultMessage='к кредитам'
        />
    ),
    [BONUS_TYPES.EXTRA_FREE_XP]: (
        <FormattedMessage
            id='bonus_type.extra_free_xp'
            defaultMessage='к свободному опыту'
        />
    ),
}

export const UP_TO_PERCENT = (value) => {
    return (
        <FormattedMessage
            id='bonus_type.up_to_value'
            defaultMessage={'до +{value}'}
            values={{
                value,
            }}
        />
    )
}

export const METERS_VALUE = (value) => {
    return (
        <FormattedMessage
            id='bonus_type.meters_value'
            defaultMessage={'{value} м'}
            values={{
                value,
            }}
        />
    )
}

export const BATTLE_TYPE_MESSAGES = {
    [BATTLE_TYPES.ALL_BATTLES]: (
        <FormattedMessage
            id='battle_types.all_battles'
            defaultMessage='Во всех режимах боев'
        />
    ),
    [BATTLE_TYPES.RANDOM_BATTLES]: (
        <FormattedMessage
            id='battle_types.random_battles'
            defaultMessage='В Случайных боях и на Линии фронта'
        />
    ),
    [BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER]: (
        <FormattedMessage
            id='battle_types.random_battles.steel_hunter'
            defaultMessage='В Случайных боях, а также на Линии фронта и в Стальном охотнике'
        />
    ),
    [BATTLE_TYPES.CLAN_BATTLES]: (
        <FormattedMessage
            id='battle_types.clan_battles'
            defaultMessage='В клановых и турнирных боях'
        />
    ),
    [BATTLE_TYPES.SORTIE]: (
        <FormattedMessage
            id='battle_types.sortie'
            defaultMessage='В Вылазках'
        />
    ),
    [BATTLE_TYPES.BATTLE_FOR_STRONGHOLD]: (
        <FormattedMessage
            id='battle_types.battles_for_stronghold'
            defaultMessage='За результат проведённого Наступления'
        />
    ),
    [BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE]: (
        <FormattedMessage
            id='battle_types.battles_for_stronghold_and_sorties'
            defaultMessage='В Вылазках и при Наступлениях на 1 бой'
        />
    ),
}

export const RESERVE_USAGE_BATTLE_TYPES = {
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='reserve_usage_battle_types.inspiration'
            defaultMessage='Используется в Вылазках и при Наступлениях на 1 бой'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='reserve_usage_battle_types.artillery_strike'
            defaultMessage='Используется в Вылазках и при Наступлениях на 1 бой'
        />
    ),
}

export const EFFECT_ON_USE_TITLE = (
    <FormattedMessage
        id='battle_reserve.effect_on_use_title'
        defaultMessage='Эффект при использовании'
    />
)

export const EFFECT_ON_USE_DESCRIPTION = {
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='battle_reserve.effect_on_use_description.inspiration'
            defaultMessage='Добавляет бонус к основным специальностям и всем умениям экипажа машины игрока с Воодушевлением и ближайших союзников в Вылазках и при Наступлениях на 1 бой'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='battle_reserve.effect_on_use_description.artillery_strike'
            defaultMessage='Артиллерийская батарея выполняет залп по указанной площади в Вылазках и при Наступлениях на 1 бой'
        />
    ),
}

export const ADDITIONAL_EFFECT_ON_USE_TITLE = (
    <FormattedMessage
        id='battle_reserve.additional_effect_on_use_title'
        defaultMessage='Дополнительный эффект'
    />
)

export const ADDITIONAL_EFFECT_ON_USE_DESCRIPTION = {
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='battle_reserve.additional_effect_on_use_description.inspiration'
            defaultMessage='к промресурсу на 1 бой при воодушевлении'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='battle_reserve.additional_effect_on_use_description.artillery_strike'
            defaultMessage='к промресурсу при вызове артобстрела'
        />
    ),
}

export const STRONGHOLD = (
    <FormattedMessage
        id="stronghold"
        defaultMessage="Укрепрайон"
    />
)

export const FORT_BATTLE = (
    <FormattedMessage
        id="fort_battle_singular"
        defaultMessage="Наступление"
    />
)

export const FORT_BATTLES = (
    <FormattedMessage
        id="fort_battles_plural"
        defaultMessage="Наступления"
    />
)

export const SORTIE = (
    <FormattedMessage
        id='sortie_singular'
        defaultMessage='Вылазка'
    />
)

export const SORTIES = (
    <FormattedMessage
        id='sorties_plural'
        defaultMessage='Вылазки'
    />
)

export const SORTIE_WITH_LEVEL = level => (
    <FormattedMessage
        id='sortie_with_level_singular'
        defaultMessage='Вылазка {level}'
        values={{ level }}
    />
)

export const SORTIES_WITH_LEVEL = level => (
    <FormattedMessage
        id='sorties_with_level_plural'
        defaultMessage='Вылазки {level}'
        values={{ level }}
    />
)

export const BATTLE_TITLES = {
    [UNIT_TYPES.SORTIE]: SORTIES,
    [UNIT_TYPES.FORT_BATTLE]: FORT_BATTLES,
}

export const CHALLENGES = (
    <FormattedMessage
        id='challenges.title'
        defaultMessage='Военные игры'
    />
)

export const DURATION = (
    <FormattedMessage
        id='battle_types.duration'
        defaultMessage='Время действия'
    />
)

export const COMMAND_CENTER_TITLE = (
    <FormattedMessage
        id='command_center.title'
        defaultMessage='Командный центр'
    />
)

export const BUILDING_TITLES = {
    [BUILDING_TYPES.FINANCIAL_UNIT]: (
        <FormattedMessage
            id='building.financial_unit.title'
            defaultMessage='Финансовая часть'
        />
    ),
    [BUILDING_TYPES.MILITARY_SCHOOL]: (
        <FormattedMessage
            id='building.military_school.title'
            defaultMessage='Военное училище'
        />
    ),
    [BUILDING_TYPES.TANKODROME]: (
        <FormattedMessage
            id='building.tankodrome.title'
            defaultMessage='Танкодром'
        />
    ),
    [BUILDING_TYPES.TRAINING_UNIT]: (
        <FormattedMessage
            id='building.training_unit.title'
            defaultMessage='Учебная часть'
        />
    ),
    [BUILDING_TYPES.TRANSPORTATION_UNIT]: (
        <FormattedMessage
            id='building.transportation_unit.title'
            defaultMessage='Автотранспортная часть'
        />
    ),
    [BUILDING_TYPES.TROPHY_BRIGADE]: (
        <FormattedMessage
            id='building.trophy_brigade.title'
            defaultMessage='Трофейная бригада'
        />
    ),
    [BUILDING_TYPES.ARTILLERY_BATTALION]: (
        <FormattedMessage
            id='building.artillery_battalion.title'
            defaultMessage='Артиллерийский дивизион'
        />
    ),
    [BUILDING_TYPES.ATTACK_BOMBER_SQUADRONS]: (
        <FormattedMessage
            id='building.attack_bomber_squadrons.title'
            defaultMessage='Полк бомбардировочной авиации'
        />
    ),
    [BUILDING_TYPES.HOME_FRONT_SERVICE]: (
        <FormattedMessage
            id='building.home_front_service.title'
            defaultMessage='Служба тыла'
        />
    ),
}

export const RESERVE_TITLES = {
    [RESERVE_TYPES.BATTLE_PAYMENTS]: (
        <FormattedMessage
            id='reserve.battle_payments.title'
            defaultMessage='Боевые выплаты'
        />
    ),
    [RESERVE_TYPES.MILITARY_MANEUVERS]: (
        <FormattedMessage
            id='reserve.military_maneuvers.title'
            defaultMessage='Военные учения'
        />
    ),
    [RESERVE_TYPES.TACTICAL_TRAINING]: (
        <FormattedMessage
            id='reserve.tactical_training.title'
            defaultMessage='Тактическая подготовка'
        />
    ),
    [RESERVE_TYPES.ADDITIONAL_BRIEFING]: (
        <FormattedMessage
            id='reserve.additional_briefing.title'
            defaultMessage='Дополнительный инструктаж'
        />
    ),
    [RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT]: (
        <FormattedMessage
            id='reserve.high_capacity_transport.title'
            defaultMessage='Большегрузный транспорт'
        />
    ),
    [RESERVE_TYPES.REQUISITION]: (
        <FormattedMessage
            id='reserve.requisition.title'
            defaultMessage='Реквизиция'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='reserve.artillery_strike.title'
            defaultMessage='Артобстрел'
        />
    ),
    [RESERVE_TYPES.AIRSTRIKE]: (
        <FormattedMessage
            id='reserve.airstrike.title'
            defaultMessage='Авиаудар'
        />
    ),
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='reserve.inspiration.title'
            defaultMessage='Воодушевление'
        />
    ),
}

export const USER_ROLES = {
    [ROLES.COMMANDER]: (
        <FormattedMessage
            id='epaulettes.title.commander'
            defaultMessage='Командующий'
        />
    ),
    [ROLES.EXECUTIVE_OFFICER]: (
        <FormattedMessage
            id='epaulettes.title.executive_officer'
            defaultMessage='Заместитель командующего'
        />
    ),
    [ROLES.PERSONNEL_OFFICER]: (
        <FormattedMessage
            id='epaulettes.title.personnel_officer'
            defaultMessage='Офицер штаба'
        />
    ),
    [ROLES.COMBAT_OFFICER]: (
        <FormattedMessage
            id='epaulettes.title.combat_officer'
            defaultMessage='Командир подразделения'
        />
    ),
    [ROLES.INTELLIGENCE_OFFICER]: (
        <FormattedMessage
            id='epaulettes.title.intelligence_officer'
            defaultMessage='Офицер разведки'
        />
    ),
    [ROLES.QUARTERMASTER]: (
        <FormattedMessage
            id='epaulettes.title.quartermaster'
            defaultMessage='Офицер снабжения'
        />
    ),
    [ROLES.RECRUITMENT_OFFICER]: (
        <FormattedMessage
            id='epaulettes.title.recruitment_officer'
            defaultMessage='Офицер по кадрам'
        />
    ),
    [ROLES.JUNIOR_OFFICER]: (
        <FormattedMessage
            id='epaulettes.title.junior_officer'
            defaultMessage='Младший офицер'
        />
    ),
    [ROLES.PRIVATE]: (
        <FormattedMessage
            id='epaulettes.title.private'
            defaultMessage='Боец'
        />
    ),
    [ROLES.RECRUIT]: (
        <FormattedMessage
            id='epaulettes.title.recruit'
            defaultMessage='Новобранец'
        />
    ),
    [ROLES.RESERVIST]: (
        <FormattedMessage
            id='epaulettes.title.reservist'
            defaultMessage='Резервист'
        />
    ),
}

export const RATING_TEXT = (
    <FormattedMessage
        id='rating'
        defaultMessage='Рейтинг'
    />
)

export const ELO_RATING_TEXT = (
    <FormattedMessage
        id='stats_tooltip.rating'
        defaultMessage='Рейтинг Эло'
    />
)

export const BATTLES_ON_LEVEL = vehicleLevel => (
    <FormattedMessage
        id='ratingLabelTooltip.title'
        defaultMessage='Сражения в {vehicleLevel} дивизионе'
        values={{ vehicleLevel: toRoman(vehicleLevel) }}
    />
)

export const LEVEL_STRING = (...levels) => {
    return (
        <FormattedMessage
            id='building_tooltip.level'
            defaultMessage='{level} уровень'
            values={{ level: levels.map(toRoman).join(', ') }}
        />
    )
}

export const LEVELS_RANGE_STRING = (start, end) => {
    return (
        <FormattedMessage
            id='building_tooltip.levels_range'
            defaultMessage='Level {start} — {end}'
            values={{ start: toRoman(start), end: toRoman(end) }}
        />
    )
}

export const BATTLES_TITLE = (
    <FormattedMessage
        id='clan_journal.data_information.tooltip.battles.subheader'
        defaultMessage='Бои'
    />
)

export const POST_BATTLE_TABLE_HEADER = {
    results: (
        <FormattedMessage
            id='post_battle_table_header.results'
            defaultMessage='Результат боя'
        />
    ),
    points: (
        <FormattedMessage
            id='post_battle_table_header.points'
            defaultMessage='Точка'
        />
    ),
    maps: (
        <FormattedMessage
            id='post_battle_table_header.maps'
            defaultMessage='Карта'
        />
    ),
}

export const ROUND_SCORE_TITLE = (
    <FormattedMessage
        id='post_battle.round_result.score.title'
        defaultMessage='Счёт'
    />
)

export {
    getMessageForControllingPointsCount,
    NAME_BY_DIRECTION,
    NAME_BY_DIRECTION_SPELLED,
    ROUND_RESULT_MESSAGES,
} from 'helpers/i18n/fort_battles'

export const SERIES_RESULT = (
    <FormattedMessage
        id='postbattle_details.series_result'
        defaultMessage='Результаты наступления'
    />
)

export const NEGATIVE_IR_BALANCE_HINT = (
    <FormattedMessage
        id='unavailable_battle.fine_text'
        defaultMessage='You can earn Industrial Resource by participating in clan Skirmishes or by fighting as a legionnaire in detachments of other clans, as well as in Tour Missions.'// eslint-disable-line max-len
    />
)

export const RATING_POSITION_CAPTION = (
    <FormattedMessage
        id='challenges.position_caption'
        defaultMessage='Позиция в рейтинге'
    />
)

export const RATING_POSITION = position => (
    <FormattedMessage
        id='challenges.position_message'
        defaultMessage='Позиция в рейтинге: {position}'
        values={{ position }}
    />
)

export const POSITION_SHORT = (
    <FormattedMessage
        id='position_short'
        defaultMessage='№'
    />
)

export const BONUS_NOT_APPLIED_TO_RESERVIST = (
    <FormattedMessage
        id='reserve_tooltip.bonus_not_applied_to_reservist'
        defaultMessage='Надбавку получают все игроки клана кроме Резервистов'
    />
)

export const LOADING_ERROR = {
    title: (
        <FormattedMessage
            id='clan_journal.error_title'
            defaultMessage='Ошибка загрузки данных'
        />
    ),
    message: (
        <FormattedMessage
            id='clan_journal.error_message'
            defaultMessage='Приносим извинения за временные неудобства.'
        />
    ),
    refresh_button_caption: (
        <FormattedMessage
            id='clan_journal.error_button_text'
            defaultMessage='Обновить'
        />
    ),
}

export const LESS_THAN_REQUIRED_BATTLES_COUNT = (battles, battlesRequired) => {
    return (
        <FormattedMessage
            id='elo_leaderboard.not_enough_battles'
            defaultMessage='Для попадания в рейтинг проведено боёв за 28 дней: {battles} / {battlesRequired}'
            values={{ battles, battlesRequired }}
        />
    )
}

export const CHALLENGES_END = (
    <FormattedMessage
        id='challenges.end_soon'
        defaultMessage='До завершения:'
    />
)

export const ALL_CAPTION = (
    <FormattedMessage
        id='common.captions.all'
        defaultMessage='Все'
    />
)

export const CANCEL = (
    <FormattedMessage
        id='common.cancel'
        defaultMessage='Отменить'
    />
)

export const CURRENCIES = {
    gold: (
        <FormattedMessage
            id='clan_panel.item.currencies.gold'
            defaultMessage='Золото'
        />
    ),
    crystal: (
        <FormattedMessage
            id='clan_panel.item.currencies.crystal'
            defaultMessage='Боны'
        />
    ),
    credits: (
        <FormattedMessage
            id='clan_panel.item.currencies.credits'
            defaultMessage='Кредиты'
        />
    ),
}


export const INDUSTRIAL_RESOURCE_MULTIPLIER = (multiplier) => (
    <FormattedMessage
        id='industrial_resource.multiplier'
        defaultMessage='×{multiplier}'
        values={{
            multiplier: floats(multiplier, 1),
        }}
    />
)

export const INDUSTRIAL_RESOURCE_MULTIPLIER_TEXT = (multiplierElement, addBr = false) => (
    <FormattedMessage
        id='industrial_resource.multiplier.text'
        defaultMessage='{multiplierElement} {brTag} к промресурсу'
        values={{
            multiplierElement,
            brTag: addBr ? <br /> : null,
        }}
    />
)



// WEBPACK FOOTER //
// ./helpers/i18n.jsx